module.exports = __webpack_public_path__ + "img/zhirehuohu1_0000.29dd988c.png";